import { useCallback, useEffect, useRef } from 'react';

import { Wrapper } from '@american-autonomy/ag-ui';

import SelectableFlightsGrid from 'components/SelectableFlightsGrid';

import useFlights from 'hooks/useFlights';

import { DEFAULT_SORT, PAGE_SIZE } from './constants';
import type { FlightResponse, FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ReportsFlightsGrid: FunctionComponent<Props> = ({
    onSelectionChange,
    startTimeFrom,
    startTimeTo
}) => {
    const { fetch, flights = [], isLoading } = useFlights();
    const flightsRef = useRef<FlightResponse[]>(flights);

    flightsRef.current = flights;

    useEffect(() => {
        let cancelled = false;

        (async () => {
            const generator = fetch({
                pageSize: PAGE_SIZE,
                sort: DEFAULT_SORT,
                startTimeFrom,
                startTimeTo
            });

            let done = false;

            while (!done && !cancelled) {
                const result = await generator.next();

                done = result.done ?? true;
            }
        })();

        return () => {
            cancelled = true;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSelectionChange = useCallback(
        (selectedIds: Set<string>) => {
            const selectedFlights: FlightResponse[] = flightsRef.current.filter(flight =>
                selectedIds.has(flight.id)
            );

            onSelectionChange?.(selectedFlights);
        },
        [onSelectionChange]
    );

    return (
        <Wrapper className={styles.reportsFlightsGrid}>
            <SelectableFlightsGrid
                isLoading={isLoading}
                onSelectionChange={handleSelectionChange}
                rows={flights}
            />
        </Wrapper>
    );
};

export default ReportsFlightsGrid;
